import type { AssignmentBuilderSchemaInput } from '@repo/schemas/assignment/assignmentBuilder';

import { useFormContext, useWatch } from 'react-hook-form';

import { Button } from '@/components/ui/button';
import { DateTimeRangePicker } from '@/components/ui/date-time-picker';
import { FormControl, FormField, FormItem, FormMessage } from '@/components/ui/form';

export default function AssignmentBuilderDateTimeSelector() {
  const { control, setValue } = useFormContext<AssignmentBuilderSchemaInput>();

  const dueTo = useWatch({ name: 'dueTo', control });

  return (
    <div className="w-full">
      <FormField
        name="available"
        render={({ field }) => (
          <FormItem className="w-full">
            <div className="flex justify-end">
              <Button
                size="sm"
                variant="ghost"
                type="button"
                onClick={() => {
                  setValue('available', null, {
                    shouldValidate: true,
                    shouldDirty: true,
                  });
                  setValue('dueTo', null, {
                    shouldValidate: true,
                    shouldDirty: true,
                  });
                }}
              >
                Wyczyść
              </Button>
            </div>
            <FormControl>
              <DateTimeRangePicker
                from={field.value}
                to={dueTo}
                ref={field.ref}
                name={field.name}
                disabled={field.disabled}
                onBlur={field.onBlur}
                onFromChange={(value) =>
                  setValue('available', value, {
                    shouldValidate: true,
                    shouldDirty: true,
                  })
                }
                onToChange={(value) =>
                  setValue('dueTo', value, {
                    shouldValidate: true,
                    shouldDirty: true,
                  })
                }
                className="w-full"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField name="dueTo" render={() => <FormMessage />} />
    </div>
  );
}
